<ion-content class="ion-padding">
    <div class="header"></div>
    <ion-grid>
        <ion-row>
            <ion-col>
                <div class="wrapper" *ngIf="!forceCloseSelfEvaluationStep; else elseBlock">
                    {{'performanceCycles.confirmCloseStep' | translate}}
                </div>
                <ng-template #elseBlock>{{'performanceCycles.confirmCloseFlagEnableStep' | translate}}</ng-template>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>

<ion-footer mode="ios">
    <ion-toolbar mode="ios">
        <ion-row>
            <ion-col>
                <div class="button-wrapper">
                    <ion-button mode="ios" color="primary" (click)="confirm()">
                        {{ 'generic.confirm' | translate }}
                    </ion-button>
                    <ion-button mode="ios" color="secondary" (click)="dismiss()">
                        {{ 'generic.cancel' | translate }}
                    </ion-button>
                </div>
            </ion-col>
        </ion-row>
    </ion-toolbar>
</ion-footer>
